import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DashboardRes;
export const DashboardTodo = createAsyncThunk('Dashboard', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'admin_dashboard',
            params:{
                "user_id": localStorage.getItem('user_id')
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DashboardRes = res.data

    } catch (error) {
        return DashboardRes = error.response.data
    }
})

const DashboardSlice = createSlice({
    name: 'Dashboard',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DashboardTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(DashboardTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DashboardSlice.reducer; 